// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"23165cf6","239":"59f1559e","667":"81b6dbc7"}[chunkId] + ".chunk.js";
};